import React from 'react';
import type { FC } from 'react';
import type { PlatformsType } from '@wix/cli-app-installer';
import { getSiteRedirectUrl, getAppPreviewUrl } from '@wix/cli-app-installer';
import { useProjectModel } from '../../model.js';
import { PlatformLink } from './PlatformLink.js';

interface PlatformLinkProps {
  versionOverrideId: string;
  platform: PlatformsType;
  siteId?: string;
}

interface RedirectOptions extends PlatformLinkProps {
  appId: string;
}

export const createRedirectLink = ({ siteId, ...options }: RedirectOptions) => {
  if (siteId != null) {
    return getSiteRedirectUrl({ ...options, siteId });
  }

  return getAppPreviewUrl(options);
};

export const RedirectLink: FC<PlatformLinkProps> = ({
  platform,
  versionOverrideId,
  siteId,
}) => {
  const { model } = useProjectModel();
  const url = createRedirectLink({
    platform,
    appId: model.config.appId,
    versionOverrideId,
    siteId,
  });
  return <PlatformLink platform={platform} url={url} />;
};
